import { ErrorBoundaryWithLogging } from "app/pages/sales-intelligence/common-components/ErrorBoundaryWithLogging";
import { AIAgentMeetingErrorView } from "app/pages/sales-intelligence/pages/ai-agent/components/AIAgentMeetingErrorView/AIAgentMeetingErrorView";
import { AIAgentMeetingLatestPageContent } from "app/pages/sales-intelligence/pages/ai-agent/containers/AIAgentMeetingLatestPageContent";

export const AIAgentMeetingLatestPageContainer = () => {
    return (
        <ErrorBoundaryWithLogging FallbackComponent={AIAgentMeetingErrorView}>
            <AIAgentMeetingLatestPageContent />
        </ErrorBoundaryWithLogging>
    );
};
